import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../../headerone/Main'
import { Row, Col } from 'react-bootstrap';
import Committeeleft from './Committeeleft';
import Breadcrumb from '../../Breadcrumb/Main'
import { Table } from 'react-bootstrap';

function Main() {

    return (
        <>
            <Header />
            <Breadcrumb title='Home' subtitle="Service Matters Committee" />
            <section className="team-area fix p-relative pt-120 pb-80">
                <div className="container">
                    <div className="lower-content">

                        <Row>

                        <Col md={3} className='c-left custom-padding-color mb-4'>
                        <Committeeleft></Committeeleft>
                        </Col>
                
                        <Col md={9} className='c-right'>

                            
                                <h3 className='c-headline mb-3'>Service Matters Committee</h3>
                                <p className='caboutus c-lineheight2dot5'>This is to inform all that the Service Matters Committee for the employees of the Institute is re-constituted with the following members, until further orders:</p>

                               
                                <Table bordered responsive className='mt-3'>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <p>Dean, Administration & Finance*</p>
                                                
                                            </td>
                                            <td>Chairperson</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Registrar*</p>
                                               
                                                
                                            </td>
                                            <td> Member</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Dean - Faculty Affairs*</p>
                                                
                                            </td>
                                            <td>Member</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Dr. Durga Prasad Challa</p>
                                                <p>Associate Professor, Department of Mathematics and Statistics</p>
                                            </td>
                                            <td>Member</td>
                                        </tr>

                                        

                                        <tr>
                                            <td>
                                                <p>Mr. T Satish Kumar</p>
                                                <p>Technical Officer, Department of Electrical Engineering</p>
                                            </td>
                                            <td>Member</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Joint Registrar / Deputy Registrar</p>
                                                <p>Establishment*</p>
                                            </td>
                                            <td>Member <br />Secretary</td>
                                        </tr>

                                                                                
                                    </tbody>

                                </Table>
                                <p className='caboutus c-lineheight2dot5'><small>*on Ex-Officio basis</small></p>

                                <p className='caboutus c-lineheight2dot5'>  Invited members- Deputy Registrar/Assistant Registrar, Finance & Accounts and Assistant Registrar, Recruitment.</p>
                                
                                <p className=' fw-bold c-headline caboutus mt-3 mb-3'> Key Functions of the Committee:</p>
                                <ul className='ms-3 c-lineheight2dot5 iarrow caboutus' >
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />  Examine the service matters related to Pay Fixation, Promotions, Service benefits (LTC, CEA, CPDA), Deputation, Lien and other allied matters.</li>
                                    
                                </ul>

                                </Col>

                           
                        </Row>

                    </div>
                </div>
            </section>
        </>
    )
}

export default Main;